<template>
  <div>
    <input type="button" id="order-btn" :disabled="disabled" :title="title" :class="['btn', disabled ? 'btn-outline-primary' : 'order-btn-active', 'mb-1']" value="Place order" @click="handleClick"/>
  </div>
</template>


<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },

  emits: ['click'],

  methods: {
    handleClick() {
      this.$emit('click');
    }
  },
}

</script>

<style scoped>
#order-btn {
  font-size:24px;
  padding:1em 2em;
}
.order-btn-active {background:#007bff; color:#ffffff;}

</style>



// WEBPACK FOOTER //
// OrderButton.vue?16bb0b3a